<div class="playList" *ngIf="currentPlayList !== null" [@fadeInOut]="animationPlaylistStateOut? 'out':'in'">
    <div class="leftContent">
        <span class="libelleTitle" *ngIf="currentPlayList?.previousNews !== null"
            [innerHTML]="'PLAYLIST.PREVIOUS' | translate"></span>
        <div class="previousNews">
            <div class="news" *ngIf="currentPlayList?.previousNews !== null"
                [@fadePrevious]="animationStateOut? 'out':'in'">
                <div class="image">
                    <img id="image0" class="hide" *ngIf="currentPlayList.previousNews.image.length > 0" fallback="../../../assets/logo/defaultThumbnail.png?i=1" (load)="chargeCanvas(currentPlayList.previousNews, 0)"
                        [src]="currentPlayList.previousNews.image[0]" alt="">
                        <canvas id="canvas0" *ngIf="currentPlayList.previousNews.image.length > 0"></canvas>
                        <div class="defaultImage" *ngIf="currentPlayList.previousNews.image.length === 0">
                            <img class="logo" src="../../../assets/logo/logo_default_news.svg?i=1" alt="">
                        </div>
                </div>
                <div class="text"
                    *ngIf="currentPlayList?.previousNews?.title !== null && currentPlayList?.previousNews?.title !== ''">
                    <p [innerHTML]="currentPlayList.previousNews.title | translate">
                    </p>
                </div>
                <div class="text"
                    *ngIf="(currentPlayList?.previousNews?.title === null || currentPlayList?.previousNews?.title === '') && currentPlayList?.previousNews?.description !== null">
                    <p [innerHTML]="currentPlayList.previousNews.description">
                    </p>
                </div>
            </div>
            <div class="news" *ngIf="currentPlayList?.currentNews !== null"
                [@arriveCurrent]="animationStateOut ? 'in':'out'">
                <div class="image">
                    <img id="image99" class="hide" *ngIf="currentPlayList.currentNews.image.length > 0" fallback="../../../assets/logo/defaultThumbnail.png?i=1" (load)="chargeCanvas(currentPlayList.currentNews, 99)"
                    [src]="currentPlayList.currentNews.image[0]" alt="">
                    <canvas id="canvas99" *ngIf="currentPlayList.currentNews.image.length > 0"></canvas>
                </div>
                <div class="text"
                    *ngIf="currentPlayList?.currentNews?.title !== null && currentPlayList?.currentNews?.title !== ''">
                    <p [innerHTML]="currentPlayList.currentNews.title">
                    </p>
                </div>
                <div class="text"
                    *ngIf="(currentPlayList?.currentNews?.title === null || currentPlayList?.currentNews?.title === '') && currentPlayList?.currentNews?.description !== null">
                    <p [innerHTML]="currentPlayList.currentNews.description">
                    </p>
                </div>
            </div>
            <div class="currentContent">
                <span class="dot"></span>
            </div>
        </div>
    </div>
    <div class="rightContent">
        <div class="nextContent">
            <span class="libelleTitle" *ngIf="currentPlayList?.nextNews1 !== null"
                [innerHTML]="'PLAYLIST.NEXT' | translate"></span>
            <div class="nextNews">
                <div class="news" *ngIf="currentPlayList?.nextNews1 !== null"
                    [@leaveNext1]="animationStateOut ? 'out':'in'">
                    <div class="image">
                        <img id="image1" class="hide" *ngIf="currentPlayList.nextNews1.image.length > 0" fallback="../../../assets/logo/defaultThumbnail.png?i=1" (load)="chargeCanvas(currentPlayList.nextNews1,1)"
                            [src]="currentPlayList.nextNews1.image[0]" alt="">
                        <canvas id="canvas1" *ngIf="currentPlayList.nextNews1.image.length > 0"></canvas>
                        <div class="defaultImage" *ngIf="currentPlayList.nextNews1.image.length === 0">
                            <img class="logo" src="../../../assets/logo/logo_default_news.svg?i=1" alt="">
                        </div>
                    </div>
                    <div class="text"
                        *ngIf="currentPlayList?.nextNews1?.title !== null && currentPlayList?.nextNews1?.title !== ''">
                        <p [innerHTML]="currentPlayList.nextNews1.title | translate">
                        </p>
                    </div>
                    <div class="text"
                        *ngIf="(currentPlayList?.nextNews1?.title === null || currentPlayList?.nextNews1?.title === '') && currentPlayList?.nextNews1?.description !== null">
                        <p [innerHTML]="currentPlayList.nextNews1.description">
                        </p>
                    </div>
                </div>
                <div class="news" *ngIf="currentPlayList?.nextNews2 !== null"
                    [@leaveNext2]="animationStateOut ? 'out':'in'">
                    <div class="image">
                        <img id="image2" class="hide" *ngIf="currentPlayList.nextNews2.image.length > 0" fallback="../../../assets/logo/defaultThumbnail.png?i=1" (load)="chargeCanvas(currentPlayList.nextNews2, 2)"
                        [src]="currentPlayList.nextNews2.image[0]" alt="">
                        <canvas id="canvas2" *ngIf="currentPlayList.nextNews2.image.length > 0"></canvas>
                        <div class="defaultImage" *ngIf="currentPlayList.nextNews2.image.length === 0">
                            <img class="logo" src="../../../assets/logo/logo_default_news.svg?i=1" alt="">
                        </div>
                    </div>
                    <div class="text"
                        *ngIf="currentPlayList?.nextNews2?.title !== null && currentPlayList?.nextNews2?.title !== ''">
                        <p [innerHTML]="currentPlayList.nextNews2.title  | translate">
                        </p>
                    </div>
                    <div class="text"
                        *ngIf="(currentPlayList?.nextNews2?.title === null || currentPlayList?.nextNews2?.title === '') && currentPlayList?.nextNews2?.description !== null">
                        <p [innerHTML]="currentPlayList.nextNews2.description">
                        </p>
                    </div>
                </div>
                <div class="news" *ngIf="currentPlayList?.nextNews3 !== null"
                    [@leaveNext3]="animationStateOut ? 'out':'in'">
                    <div class="image">
                        <img id="image3" class="hide" *ngIf="currentPlayList.nextNews3.image.length > 0" fallback="../../../assets/logo/defaultThumbnail.png?i=1" (load)="chargeCanvas(currentPlayList.nextNews3,3)"
                        [src]="currentPlayList.nextNews3.image[0]" alt="">
                        <canvas id="canvas3" *ngIf="currentPlayList.nextNews3.image.length > 0"></canvas>
                        <div class="defaultImage" *ngIf="currentPlayList.nextNews3.image.length === 0">
                            <img class="logo" src="../../../assets/logo/logo_default_news.svg?i=1" alt="">
                        </div>
                    </div>
                    <div class="text"
                        *ngIf="currentPlayList?.nextNews3?.title !== null && currentPlayList?.nextNews3?.title !== ''">
                        <p [innerHTML]="currentPlayList.nextNews3.title  | translate">
                        </p>
                    </div>
                    <div class="text"
                        *ngIf="(currentPlayList?.nextNews3?.title === null || currentPlayList?.nextNews3?.title === '') && currentPlayList?.nextNews3?.description !== null">
                        <p [innerHTML]="currentPlayList.nextNews3.description">
                        </p>
                    </div>
                </div>
                <div class="news" *ngIf="currentPlayList?.nextNews4 !== null"
                    [@leaveNext4]="animationStateOut ? 'out':'in'">
                    <div class="image">
                        <img id="image4" class="hide" *ngIf="currentPlayList.nextNews4.image.length > 0" fallback="../../../assets/logo/defaultThumbnail.png?i=1" (load)="chargeCanvas(currentPlayList.nextNews4,4)"
                        [src]="currentPlayList.nextNews4.image[0]" alt="">
                        <canvas id="canvas4" *ngIf="currentPlayList.nextNews4.image.length > 0"></canvas>
                        <div class="defaultImage" *ngIf="currentPlayList.nextNews4.image.length === 0">
                            <img class="logo" src="../../../assets/logo/logo_default_news.svg?i=1" alt="">
                        </div>
                    </div>
                    <div class="text"
                        *ngIf="currentPlayList?.nextNews4?.title !== null && currentPlayList?.nextNews4?.title !== ''">
                        <p [innerHTML]="currentPlayList.nextNews4.title  | translate">
                        </p>
                    </div>
                    <div class="text"
                        *ngIf="(currentPlayList?.nextNews4?.title === null || currentPlayList?.nextNews4?.title === '') && currentPlayList?.nextNews4?.description !== null">
                        <p [innerHTML]="currentPlayList.nextNews4.description">
                        </p>
                    </div>
                </div>
                <div class="news" *ngIf="currentPlayList?.nextNews5 !== null"
                    [@leaveNext5]="animationStateOut ? 'in':'out'">
                    <div class="image">
                        <img id="image5" class="hide" *ngIf="currentPlayList.nextNews5.image.length > 0" fallback="../../../assets/logo/defaultThumbnail.png?i=1" (load)="chargeCanvas(currentPlayList.nextNews5, 5)"
                        [src]="currentPlayList.nextNews5.image[0]" alt="">
                        <canvas id="canvas5" *ngIf="currentPlayList.nextNews5.image.length > 0"></canvas>
                        <div class="defaultImage" *ngIf="currentPlayList.nextNews5.image.length === 0">
                            <img class="logo" src="../../../assets/logo/logo_default_news.svg?i=1" alt="">
                        </div>
                    </div>
                    <div class="text"
                        *ngIf="currentPlayList?.nextNews5?.title !== null && currentPlayList?.nextNews5?.title !== ''">
                        <p [innerHTML]="currentPlayList.nextNews5.title  | translate">
                        </p>
                    </div>
                    <div class="text"
                        *ngIf="(currentPlayList?.nextNews5?.title === null || currentPlayList?.nextNews5?.title === '') && currentPlayList?.nextNews5?.description !== null">
                        <p [innerHTML]="currentPlayList.nextNews5.description">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>